import authService from '@/services/authService';

const state = {
  user: null,
  isAuthenticated: false,
  loading: false,
  error: null
};

const getters = {
  isAuthenticated: state => state.isAuthenticated,
  currentUser: state => state.user,
  authLoading: state => state.loading,
  authError: state => state.error
};

const mutations = {
  SET_USER(state, user) {
    state.user = user;
    state.isAuthenticated = !!user;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  CLEAR_ERROR(state) {
    state.error = null;
  }
};

const actions = {
  async login({ commit }, { email, password }) {
    commit('SET_LOADING', true);
    commit('CLEAR_ERROR');
    
    try {
      const response = await authService.login(email, password);
      commit('SET_USER', response.user);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Login failed';
      commit('SET_ERROR', errorMessage);
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  logout({ commit }) {
    authService.logout();
    commit('SET_USER', null);
    commit('CLEAR_ERROR');
  },

  async checkAuth({ commit }) {
    if (authService.isAuthenticated()) {
      const user = authService.getCurrentUser();
      if (user) {
        commit('SET_USER', user);
        return true;
      }
    }
    return false;
  },

  async refreshToken({ commit }) {
    try {
      const response = await authService.refreshToken();
      commit('SET_USER', response.user);
      return response;
    } catch (error) {
      commit('SET_USER', null);
      throw error;
    }
  },

  // Check if token needs refresh and refresh if needed
  async checkAndRefreshToken({ commit, dispatch }) {
    if (authService.isAuthenticated() && authService.isTokenExpired()) {
      try {
        await dispatch('refreshToken');
        return true;
      } catch (error) {
        commit('SET_USER', null);
        return false;
      }
    }
    return true;
  },

  clearError({ commit }) {
    commit('CLEAR_ERROR');
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}; 